// (c) 2026 Owl Consultations. All rights reserved.
// Proprietary and confidential — licensed use only. Unauthorized use,
// copying, or distribution is prohibited and may be prosecuted.

import StationQueue from './StationQueue'

/**
 * On Hold queue — Rxs paused mid-workflow.
 *
 * Per U-04 (PharmacistInCharge): hold reasons are diverse (DUR conflict,
 * patient unreachable, drug recall, payment issue, etc.) so the operator
 * needs the timeline/comments on the detail page to know how to clear
 * each one. This queue just surfaces what's stuck.
 *
 * The `hold_returns_to` column on rx_items records where the Rx came
 * from before going on hold; releasing returns it to that state. That's
 * surfaced on the Rx detail page, not the queue table (too noisy).
 */
export default function OnHoldTab() {
  return (
    <StationQueue
      states="on_hold"
      tabKey="hold"
      title="On hold"
      subtitle="Prescriptions paused mid-workflow and waiting to be cleared."
      emptyMessage="No prescriptions on hold."
    />
  )
}
